import Actions from '../../odata/actions';

const actions = new Actions('sectionLineItemAudit', 'sectionLineItemAudits');

export default actions;
